import { IconComponent } from '../icon.types';

export const CancelBigIcon: IconComponent = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M22 2L2 22" stroke="currentColor" strokeWidth="2" />
    <path d="M2 2L22 22" stroke="currentColor" strokeWidth="2" />
  </svg>
);
